import { Table, Input, Space, Button, Checkbox } from "antd";
import React, { useState, useRef, useEffect } from "react";
import {
  UploadOutlined,
  PrinterOutlined,
  DeleteOutlined,
  EditOutlined,
  BarsOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { IntToBetrag } from "../Helper/ZahlenFormat";
import TextArea from "antd/es/input/TextArea";
import { LayoutData } from "../Structur/Aconlayout";
import { getKontoSoll, getKontoHaben } from "../Helper/PrKontoHelper";

export const KontenListe = ({
  dataSource,
  aktjahr,
  aktklasse,
  loading,
  onChange,
  onJournalShow,
  title,
  mitSelektion,
  setSelectedRows,
  tableArt,
}) => {
  const {
    aconMainContainer,
    user,
    userDaten,
    windowWidth,
    aktSumsComponent,
    logout,
    mainContainerHeight,
  } = LayoutData();

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const handleOnEditclick = (kontoData) => {
    //console.log("handleOnEditclick",kontoData);
    if (onChange) onChange(kontoData);
  };
  const handleOnJournalClick = (kontoData) => {
    if (onJournalShow) onJournalShow(kontoData);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getKontoSaldo = (record) => {
    //console.log(record);
    return getKontoSoll(record) - getKontoHaben(record);
  };

  const getColumns = () => {
    const columns = [
      {
        title: "Jour",
        key: "action",
        width: 50,
        render: (text, record) => (
          <>
            {getKontoSoll(record) + getKontoHaben(record) !== 0 && (
              <span
                onClick={() => handleOnJournalClick(record)}
                style={{ cursor: "pointer" }}
              >
                <BarsOutlined style={{ fontSize: 20 }} />
              </span>
            )}
          </>
        ),
      },

      {
        title: "Edit",
        key: "action",
        width: 50,
        render: (text, record) => (
          <span
            onClick={() => handleOnEditclick(record)}
            style={{ cursor: "pointer" }}
          >
            <EditOutlined style={{ fontSize: 20 }} />
          </span>
        ),
      },
      {
        title: "Konto",
        dataIndex: "konto",
        width: 80,
        minWidth: 80,
        align: "right",
        render: (text) => <>{IntToBetrag(text)}</>,
      },
      {
        title: "Name",
        dataIndex: "Suchbeg",
        fixed: "left",
        width: 200,
        minWidth: 100, // Mindestbreite der Spalte
        //ellipsis: true,
        render: (text, record) => <b>{text}</b>,
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8 }}>
            <Input
              placeholder="Name suchen"
              value={selectedKeys[0]}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() =>
                handleSearch(selectedKeys, confirm, "Suchbeg")
              }
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, "Suchbeg")}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button
                onClick={() => handleReset(clearFilters)}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) =>
          record.Suchbeg
            ? record.Suchbeg.toString()
                .toLowerCase()
                .includes(value.toLowerCase()) /* ||
                  record.Vorname.toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())*/
            : "",
      },
    ];
    const doPushArt1 = () => {
      columns.push({
        title: "Soll",
        dataIndex: "konto",
        width: 80,
        minWidth: 80,
        align: "right",
        render: (text, record) => <>{IntToBetrag(getKontoSoll(record))}</>,
      });
      columns.push({
        title: "Haben",
        dataIndex: "konto",
        width: 80,
        minWidth: 70,
        align: "right",
        render: (text, record) => <>{IntToBetrag(getKontoHaben(record))}</>,
      });

      columns.push({
        title: "Saldo",
        dataIndex: "konto",
        width: 80,
        minWidth: 70,
        align: "right",
        render: (text, record) => <>{IntToBetrag(getKontoSaldo(record))}</>,
      });
      columns.push({
        title: "Eröff.",
        dataIndex: "konto",
        width: 80,
        minWidth: 70,
        align: "right",
        render: (text, record) => <>{IntToBetrag(record.bilanzopen)}</>,
      });
      columns.push({
        title: "Abschl.",
        dataIndex: "konto",
        width: 80,
        minWidth: 70,
        align: "right",
        render: (text, record) => <>{IntToBetrag(record.bilanzclose)}</>,
      });
    };
    const doPushArt2 = () => {
      columns.push({
        title: "BA",
        dataIndex: "bilanzabschluss",
        width: 55,
        minWidth: 40,
        render: (bo) => (
          <>
            <Checkbox checked={bo} />
          </>
        ),
        align: "center",
      });
      columns.push({
        title: "VJ",
        dataIndex: "uebertrag",
        width: 55,
        minWidth: 40,
        render: (bo) => (
          <>
            <Checkbox checked={bo} />
          </>
        ),
        align: "center",
      });

      columns.push({
        title: "BPos",
        dataIndex: "bilanzpos",
        width: 80,
        align: "right",
      });

      columns.push({
        title: "IN/EU/AU",
        dataIndex: "inladeuaus",
        width: 80,
        align: "center",
        render: (inau) => (
          <>{inau === 0 ? "Inland" : inau === 1 ? "EU" : "Ausland"}</>
        ),
      });
    };

    switch (tableArt) {
      case 1:
        doPushArt1();
        break;
      case 2:
        doPushArt2();

        break;
      case 3:
        doPushArt1();
        doPushArt2();
        break;
      default:
    }

    return columns;
  };

  const cancel = () => {};

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
      setSelectedRows(selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      // Column configuration not to be checked
      name: record.name,
    }),
  };
  return (
    <>
      {/*
  Liste der Konten hier  {aktjahr}, {aktklasse} - Search: {searchText}
    */}

      <Table
        title={title}
        rowSelection={mitSelektion && rowSelection}
        size="small"
        columns={getColumns()}
        dataSource={dataSource}
        bordered
        loading={loading}
        fixed
        pagination={{
          // pageSize: 50,
          onChange: cancel,
        }}
        scroll={{
          y: mainContainerHeight > 380 ? mainContainerHeight - 270 : 120,
        }}
      />
    </>
  );
};
